import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from '@/store/modules/auth'
import toast from '@/store/modules/toast'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
    activeItem: '',
    errorStatus: false,
    errorMessage: ''
  },
  modules: {
    auth,
    toast
  },
  getters: {
    getErrorStatus (state) { return state.errorStatus }
  },
  mutations: {
    activeSidebar (state, name) {
      state.activeItem = name
    },
    setError (state, message) {
      state.errorStatus = true
      state.errorMessage = message
    }
  },
  plugins: [
    createPersistedState({
      key: 'example',
      paths: ['auth'],
      storage: window.sessionStorage
    })
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js